import React from "react";
import { Box, Spacer, Stack } from "digiwash-components";

function SkeletonCategoriesFilter() {
  let array = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  return (
    <Box px="m" style={{ width: "100%", overflow: "hidden" }}>
      <Stack>
        {array.map(() => {
          return (
            <>
              <Box
                br="l"
                bg="primary.light980"
                style={{ width: 101, height: 50 }}
              />
              <Spacer size="m" />
            </>
          );
        })}
      </Stack>
    </Box>
  );
}

export default SkeletonCategoriesFilter;
